module.exports = __webpack_public_path__ + "static/media/trilloThumbnail.8234e7df.png";